const PERMISSIONS_SKU_PAGE = {
  VIEW: 'voucherpin_sku::get',
  CREATE: 'voucherpin_sku::create',
  UPDATE: 'voucherpin_sku::update',
} as const;

export default PERMISSIONS_SKU_PAGE;
